import '@hotwired/turbo-rails'
import { FetchRequest } from '@rails/request.js'
window.FetchRequest = FetchRequest
